export namespace Constantes {

export const NOUVEAU:string="NOUVEAU";  
export const RUBRIQUE:string="RUBRIQUE";
export const FACADE:string="FACADE";
export const DESIGN:string="DESIGN";
export const MATERIAU:string="MATERIAU";
export const MODELE:string="MODELE";
export const COULEUR:string="COULEUR";
export const POIGNEE:string="POIGNEE";
export const ACCESSOIRE:string="ACCESSOIRE";
export const VITRAGE:string="VITRAGE";
export const DOCUMENT_PDF:string="PDF";

export const RUBRIQUE_FACADES:string="facades";
export const RUBRIQUE_DESIGNS:string="design";
export const RUBRIQUE_MATERIAUX:string="materiaux";
export const RUBRIQUE_MODELES:string="modeles";
export const RUBRIQUE_COULEURS:string="couleurs";
export const RUBRIQUE_POIGNEES:string="poignees";
export const RUBRIQUE_ACCESSOIRES:string="accessoires";
export const RUBRIQUE_VITRAGES:string="vitrages";
export const RUBRIQUE_DOCUMENT:string="pdf";

}

export abstract class AConfigurateurPE {
    name:string;
    code:string;
    img:string;
}

export class ConfigurateurInit {
    version:string;
    background_img:string;
    titre1:string;
    titre2:string;
    familles:ConfigurateurFamille[];
}

export class ConfigurateurFamille extends AConfigurateurPE {
    groupes:ConfigurateurGroupe[];
}

export class ConfigurateurGroupe extends AConfigurateurPE {
    famille:ConfigurateurFamille;
}

export class ConfigurateurData {
    clientId:string;
    version:string;
    uploadImg: string;
    noAccessoireImg:string;
    closeImg:string;
    defaultCodeFacade:string;
    enseigneActive:ConfigurateurEnseigne;
    groupe:ConfigurateurGroupe;
    rubriques:ConfigurateurRubrique[];
    facades:ConfigurateurFacade[];
    designs:ConfigurateurDesign[];
    materiaux:ConfigurateurMateriau[];
    modeles:ConfigurateurModele[];
    couleurs:ConfigurateurCouleur[];
    poignees:ConfigurateurPoignee[];
    accessoires:ConfigurateurAccessoire[];
    vitrages:ConfigurateurVitrage[];
    renderModeles:RenderModele[];
    renderDefaults:RenderDefault[];
}

export interface IConfigurateurItemType {
    itemType:string;
}
export abstract class AConfigurateurDataPE extends AConfigurateurPE implements IConfigurateurItemType {
    order:number;
    itemType:string;
}

export class ConfigurateurRubrique extends AConfigurateurDataPE {
    itemCode:string;
    disable:boolean;
}

export class RenderModele extends AConfigurateurDataPE {

    codeDesign:string;
    codeMateriau:string;
    codeModele:string;
    codeCouleur:string;
    nameGroupe:string;
    nameModele:string;
    nameCouleur:string;
    nameDesign:string;
    nameMateriau:string;
}

export class RenderDefault extends RenderModele {

    codeVitrage:string;
    codePoignee:string;
    codeAccessoire:string;
}

export class ConfigurateurFacade extends AConfigurateurDataPE {
    x?:number;
    y?:number;
    largeur?:number;
    hauteur?:number;
    isCustom:boolean;
    picto?:string;
}

export class ConfigurateurDesign extends AConfigurateurDataPE {

}

export class ConfigurateurMateriau extends AConfigurateurDataPE {

}
export class ConfigurateurModele extends AConfigurateurDataPE {

    materiau:ConfigurateurMateriau;
    design:ConfigurateurDesign;
    thermique:string;
    decriptif:string;
    
}

export class ConfigurateurCouleur extends AConfigurateurDataPE {
    codeModele:string;
}

export class ConfigurateurAccessoire extends ConfigurateurCouleur {
   
   x?:number;
   y?:number;
   picto?:string;
}

export class ConfigurateurPoignee extends ConfigurateurAccessoire {

}

export class ConfigurateurVitrage extends ConfigurateurAccessoire {

}
export class RenderFacade extends ConfigurateurFacade{

}
export class RenderVitrage extends ConfigurateurVitrage{

}
export class RenderAccessoire extends ConfigurateurAccessoire {
    
}
export class RenderPoignee extends ConfigurateurPoignee{
    
}
export class RenderCanvas implements IConfigurateurItemType {
    itemType:string;
    facade:RenderFacade;
    modele:RenderModele;
    vitrage:RenderVitrage;
    poignee:RenderPoignee;
    accessoire:RenderAccessoire;
}

export class ConfigurateurEnseigne extends AConfigurateurPE {
    logo:string;
    designation:string;
    telephone:string;
    email:string;
    site:string;
    adresse:string;
    titre1:string;
    titre2:string;
    pdfSetting:PdfSetting
}

export class PdfSetting {
    descriptifTitle:string;
    itemTitle:string;
    bottomTitle:string;
    colorPrimary:string;
    colorSecond:string;
    colorBackgroundTablePrimary:string;
    colorBackgroundTableSecond:string;
    filename:string;

    public getColor(color:string): number[] {

        let rgb : number[];

        if (color !== undefined && color !== null && color.length > 0) {
            rgb = color.split(',').map(a => {return parseInt(a)});
        }

        return rgb;
    }
}


// WEBPACK FOOTER //
// ./src/app/model/configurateur.ts